<div class="container p-4 bg-whitesmoke">
  <app-breadcrumb></app-breadcrumb>
  
  <!-- Statistics Grid -->
  <div class="row g-4 mb-4">
    <!-- DigivCards Card -->
    <div class="col-12 col-md-6 col-xl-6">
      <mat-card class="h-100 shadow-sm">
        <mat-card-content class="p-4">
          <div class="d-flex align-items-center mb-3">
            <mat-icon class="text-primary me-3 mat-icon-xl">credit_card</mat-icon>
            <h3 class="h6 mb-0 fw-semibold">DigivCards</h3>
          </div>

          <div *ngIf="!isLoadingStats && dashboardStats" class="text-center">
            <div class="display-6 fw-bold text-primary">{{ dashboardStats.totalCards }}</div>
            <div class="small text-muted">{{ dashboardStats.activeCards }} active</div>
          </div>

          <div *ngIf="isLoadingStats" class="d-flex flex-column align-items-center">
            <mat-spinner diameter="40" class="mb-2"></mat-spinner>
            <span class="small text-muted">Loading...</span>
          </div>

          <div *ngIf="statsError && !isLoadingStats" class="d-flex align-items-center justify-content-center text-warning">
            <mat-icon class="me-2">error</mat-icon>
            <span class="small">Error</span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Bookmarks Card -->
    <div class="col-12 col-md-6 col-xl-6">
      <mat-card class="h-100 shadow-sm">
        <mat-card-content class="p-4">
          <div class="d-flex align-items-center mb-3">
            <mat-icon class="text-primary me-3 mat-icon-xl">bookmark</mat-icon>
            <h3 class="h6 mb-0 fw-semibold">Bookmarks</h3>
          </div>

          <div *ngIf="!isLoadingStats && dashboardStats" class="text-center">
            <div class="display-6 fw-bold text-primary">{{ globalAnalytics?.bookmarks ?? dashboardStats.totalBookmarks }}</div>
          </div>

          <div *ngIf="isLoadingStats" class="d-flex flex-column align-items-center">
            <mat-spinner diameter="40" class="mb-2"></mat-spinner>
            <span class="small text-muted">Loading...</span>
          </div>

          <div *ngIf="statsError && !isLoadingStats" class="d-flex align-items-center justify-content-center text-warning">
            <mat-icon class="me-2">error</mat-icon>
            <span class="small">Error</span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Error Banner -->
  <div class="row mb-4" *ngIf="statsError && !isLoadingStats">
    <div class="col-12">
      <div class="alert alert-warning d-flex align-items-center">
        <mat-icon class="me-3">error_outline</mat-icon>
        <span class="flex-grow-1">{{ statsError }}</span>
        <button mat-raised-button color="primary" (click)="loadDashboardStats()">
          <mat-icon class="me-1">refresh</mat-icon>
          Retry
        </button>
      </div>
    </div>
  </div>

  <!-- Views / Saves / Clicks Row -->
  <div class="row g-4 mb-4" *ngIf="!isLoadingStats && dashboardStats">
    <!-- Views Card -->
    <div class="col-12 col-md-4 col-xl-4">
      <mat-card class="h-100 shadow-sm">
        <mat-card-content class="p-4">
          <div class="d-flex align-items-center mb-3">
            <mat-icon class="text-primary me-3 mat-icon-xl">visibility</mat-icon>
            <h3 class="h6 mb-0 fw-semibold">Views</h3>
          </div>

          <div class="text-center">
            <div class="display-6 fw-bold text-primary">
              {{ globalAnalytics?.views ?? dashboardStats.cardMetrics?.totalViews }}
            </div>
            <div class="small text-muted">Total Views</div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Saves Card -->
    <div class="col-12 col-md-4 col-xl-4">
      <mat-card class="h-100 shadow-sm">
        <mat-card-content class="p-4">
          <div class="d-flex align-items-center mb-3">
            <mat-icon class="text-primary me-3 mat-icon-xl">bookmark</mat-icon>
            <h3 class="h6 mb-0 fw-semibold">Saves</h3>
          </div>

          <div class="text-center">
            <div class="display-6 fw-bold text-primary">
              {{ globalAnalytics?.saves ?? dashboardStats.cardMetrics?.saves }}
            </div>
            <div class="small text-muted">Total Saves</div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Clicks Card -->
    <div class="col-12 col-md-4 col-xl-4">
      <mat-card class="h-100 shadow-sm">
        <mat-card-content class="p-4">
          <div class="d-flex align-items-center mb-3">
            <mat-icon class="text-primary me-3 mat-icon-xl">touch_app</mat-icon>
            <h3 class="h6 mb-0 fw-semibold">Clicks</h3>
          </div>

          <div class="text-center">
            <div class="display-6 fw-bold text-primary">
              {{ globalAnalytics?.clicks ?? dashboardStats.cardMetrics?.clicks }}
            </div>
            <div class="small text-muted">Total Clicks</div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Quick Actions Section -->
  <div class="row">
    <div class="col-12">
      <mat-card class="shadow-sm">
        <mat-card-header>
          <div class="d-flex align-items-center">
            <mat-icon class="text-primary me-2">flash_on</mat-icon>
            <mat-card-title class="h5 mb-0">Quick Actions</mat-card-title>
          </div>
        </mat-card-header>
        <mat-card-content class="p-4">
          <div class="row g-3">
            <div class="col-12 col-sm-6 col-lg-3">
              <button mat-raised-button routerLink="/employees"
                      class="w-100 p-3 d-flex flex-column align-items-center text-center">
                <mat-icon class="mb-2 mat-icon-2xl">people</mat-icon>
                <span class="fw-semibold">Manage Employees</span>
              </button>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
              <button mat-raised-button routerLink="/cards"
                      class="w-100 p-3 d-flex flex-column align-items-center text-center">
                <mat-icon class="mb-2 mat-icon-2xl">credit_card</mat-icon>
                <span class="fw-semibold">Manage Cards</span>
              </button>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
              <button mat-raised-button routerLink="/analytics"
                      class="w-100 p-3 d-flex flex-column align-items-center text-center">
                <mat-icon class="mb-2 mat-icon-2xl">analytics</mat-icon>
                <span class="fw-semibold">View Analytics</span>
              </button>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
              <button mat-raised-button routerLink="/app-settings"
                      class="w-100 p-3 d-flex flex-column align-items-center text-center">
                <mat-icon class="mb-2 mat-icon-2xl">settings</mat-icon>
                <span class="fw-semibold">Settings</span>
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
